<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-overview-wrapper">
  <h2>Design Overview</h2>
  <hr>
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
          routerLink="/design">Design</a>
      </li>
      <li class="breadcrumb__list__list-item"><a
          class="breadcrumb__list__list-item__link">{{design?.hvac_dsn_descrpt}}</a>
      </li>
    </ul>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex flex-wrap">
      <!-- <div class="design-overview-wrapper__item__image">
        <img src="../../assets/images/list-image.jpg" alt="">
      </div> -->
      <div class="flex-grow-1 flex-column d-flex">
        <h2 class="design-overview-wrapper__item__title">{{design?.hvac_dsn_descrpt}}</h2>
        <p class="design-overview-wrapper__item__detail">
          {{design?.contact_id}}</p>
        <p class="design-overview-wrapper__item__detail">
          ID: {{design?.hvac_design_id}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          2.1
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Ventilation airflow design rate & run-time meet the requirements of ASHRAE 62.2-2010, 2013, or 2016.</p>
        <p class="design-overview-wrapper__item__detail">{{design?.ventmeet622}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          2.2
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Ventilation airflow design rate required by 62.2 for a
          continuous system</p>
        <p class="design-overview-wrapper__item__detail">CFM - {{design?.venair622}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          1.0
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Designer Company</p>
        <p class="design-overview-wrapper__item__detail"> {{design?.companyname}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          1.1
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Design name</p>
        <p class="design-overview-wrapper__item__detail">{{design?.designername}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.1
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Room-by-room loads calculated using:</p>
        <p class="design-overview-wrapper__item__detail">{{design?.heatlossmtd}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.2
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Indoor design temperatures used in loads are 70F for heating and 75F for cooling.
          and 75°F for cooling</p>
        <p class="design-overview-wrapper__item__detail">{{design?.indoortemp}}</p>
      </div>
    </div>
  </div>

  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.3
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Outdoor design temperatures used in loads:
        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.outdoortemplocation}} Cooling Season
          {{design?.outdoor1_}} Heating Season {{design?.outdoor99_}}</p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.4
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Number of occupants used in loads:
        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.noocupants}}</p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.5
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Conditioned floor area used in loads:

        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.cfa}}</p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.6
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Window area used in loads:

        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.wa}}</p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.7
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Predominant window SHGC used in loads:

        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.shgc}}</p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.8
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Infiltration rate used in loads:

        </p>
        <p class="design-overview-wrapper__item__detail">Summer - {{design?.summerinfiltration}}</p>
        <p class="design-overview-wrapper__item__detail">Winter - {{design?.winterinfiltration}}</p>

      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          3.9
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title"> Mechanical ventilation rate used in loads:

        </p>
        <p class="design-overview-wrapper__item__detail">{{design?.mechanicalvent}} CFM</p>
      </div>
    </div>
  </div>

  <div class="row col-8 center-block dashboard-btn-row">
    <div class="d-flex my-3">
      <button mat-flat-button color="primary" class="me-3" [routerLink]="['/design-form']"
        [queryParams]="{id: design?.hvac_design_id,mode:'Edit'}">EDIT</button>
      <button mat-flat-button color="warn" class="me-3" type="button" data-toggle="collapse" data-target="#dds3"
        (click)="delete(design.hvac_design_id)" aria-expanded="false" aria-controls="dds3">
        DELETE
      </button>
      <button mat-flat-button color="basic" type="button" [routerLink]="['/design']" data-toggle="collapse"
      data-target="#dds3" aria-expanded="false" aria-controls="dds3">
      Back
    </button>
    </div>
  </div>
</div>
